export default __webpack_public_path__ + "static/bwTrentini_WithPhy-45116cc0657b13c13cd92ab8c36912e2.jpg";